<ion-content (touchstart)="onTouchStart($event)"
(touchmove)="onTouchMove($event)"
(touchend)="onTouchEnd($event)">
	<div class="wrapper">
		<div class="content">

			<header class="header">
				<img class="logo" src="assets/images/logo.svg" alt="Logo">
			</header>

			<div class="main">
				<div class="mr-potty">
					<img src="assets/images/random-question/mr_potty_both_arms_up.svg" alt="Mr Potty Both Arms Up">
				</div>

				<div class="main-content">

					<p class="title">Would you rather</p>

					<app-progress-bar [activeStep]="activeStep"></app-progress-bar>

					<div class="answers">
						<div class="answer-wrapper" *ngFor="let answer of getAnswers(); let i = index">
							<div class="answer" @answerTransition
								[ngClass]="selectedAnswer === answer ? 'selected' : ''" (click)="selectAnswer(answer)">
								{{ answer }}</div>

							<p *ngIf="i === 0" class="or">or</p>

						</div>
					</div>

					<button class="switch-btn btn-with-effect" (click)="showNextQuestion()">gimme another</button>

				</div>

				<app-navigation-buttons
					(click)="saveQuestionMetadata($event)"
					[twoButtonsShowing]="true"
					[nextButtonText]="nextButtonText"
					[isSkipButtonHidden]="true"
					[isSkipDisplayed]="this.nextButtonText === 'skip'">
				</app-navigation-buttons>

			</div>

		</div>
	</div>
</ion-content>
